import { PositiveUniversalMeasure, ShadingType, UnderlineType } from "docx";

export const useConvertTokenToRunFormatting = (
  tokenFormatting?: ParagraphTokenFormatting
) => {
  if (!tokenFormatting) return {};

  const size = tokenFormatting?.size ?? 12;

  var fontSize = size * 2;
  var shouldStrike = tokenFormatting?.strikeThrough;
  var highlight = useTokenHighlightColor(tokenFormatting?.highlightColor);

  var shading = undefined;

  if (highlight) {
    shading = {
      type: ShadingType.CLEAR,
      fill: highlight,
      color: "#FFFFFF",
    };
  }

  return {
    size: fontSize,
    color: useRGBToHex(tokenFormatting?.color ?? []),
    bold: tokenFormatting?.bold,
    italics: tokenFormatting?.italic,
    underline: tokenFormatting?.underline
      ? {
          type: UnderlineType.SINGLE,
          color: "#000000",
        }
      : undefined,
    strike: shouldStrike,
    shading,
  };
};
